import { INIT } from './app';
import api from './../lib/api';
import { sportFlagsToKeysArray } from '../lib/sportUtils';

const CREATE_PLAYGROUND = 'playgrounds/playgrounds/create';
const UPDATE_PLAYGROUND = 'playgrounds/playgrounds/update';
const UPLOAD_PHOTO = 'playgrounds/playgrounds/upload-photo';
const DELETE_PHOTO = 'playgrounds/playgrounds/delete-photo';
const SET_COVER_PHOTO = 'playgrounds/playgrounds/set-cover';
const DELETE_PLAYGROUND = 'playgrounds/playgrounds/delete-playground';
const SET_TIMETABLE = 'playgrounds/playgrounds/set-timetable';
const ADD_TIMETABLE = 'playgrounds/playgrounds/add-timetable';
const FETCH_PLAYGROUNDS = 'playgrounds/playgrounds/fetch';

function asList(value) {
  if (Array.isArray(value)) return [...value];
  if (value && Array.isArray(value.items)) return [...value.items];
  if (value && Array.isArray(value.$values)) return [...value.$values];
  return [];
}

const reducer = (state = [], action) => {
  let obj;

  switch (action.type) {
    case INIT: {
      const incoming = asList(action.payload && action.payload.playgrounds);
      if (incoming.length > 0) return incoming;
      return state.length > 0 ? state : [];
    }
    case FETCH_PLAYGROUNDS: {
      const incoming = asList(action.payload);
      if (incoming.length > 0) return incoming;
      return state.length > 0 ? state : [];
    }
    case CREATE_PLAYGROUND:
      return [...state, action.payload];
    case DELETE_PLAYGROUND:
      return state.filter(playground => playground.id !== action.payload.id);
    case UPLOAD_PHOTO: {
      const playgroundId = Number(action.payload.playground);
      obj = state.find(i => Number(i.id) === playgroundId);
      if (!obj) return state;
      if (!Array.isArray(obj.images)) obj.images = [];
      obj.images.push(action.payload.image);
      return [...state];
    }
    case DELETE_PHOTO: {
      const playgroundId = Number(action.payload.playground);
      obj = state.find(i => Number(i.id) === playgroundId);
      if (!obj) return state;
      obj.images = (obj.images || []).filter(i => i.id !== action.payload.id);
      return [...state];
    }
    case SET_COVER_PHOTO: {
      const playgroundId = Number(action.payload.playground);
      obj = state.find(i => Number(i.id) === playgroundId);
      if (!obj) return state;
      obj.images = (obj.images || []).map(i =>
        (i.id === action.payload.id ? { ...i, isMain: true } : { ...i, isMain: false }));
      return [...state];
    }
    case UPDATE_PLAYGROUND:
      obj = state.find(i => i.id === action.payload.id);
      Object.assign(obj, action.payload);
      return [...state];
    case SET_TIMETABLE:
      obj = state.find(i => i.id === action.payload.playgroundId);
      obj.timetable = action.payload.timetable;
      return [...state];
    case ADD_TIMETABLE:
      obj = state.find(i => i.id === action.payload.playgroundId);
      obj.workingHoursTypes = [...obj.workingHoursTypes, action.payload.type];
      return [...state];

    default:
      return state;
  }
};

export const createPlayground = async ({
  name,
  complexId,
  price,
  sport,
  cover,
  weekdays,
  weekend,
  tribune,
  type,
  lighting,
  workingHours,
  workingHoursSports,
}) => {
  const model = await api.createPlayground({
    name,
    complexId,
    price,
    sport,
    cover,
    weekdays,
    weekend,
    tribune,
    type,
    lighting,
    workingHours,
    sports: workingHoursSports,
  });
  if (model) {
    const { sports, ...playground } = model;
    return {
      type: CREATE_PLAYGROUND,
      payload: {
        ...playground,
        workingHoursSports: sports,
      },
    };
  }
  return true;
};

export const updatePlayground = async ({
  name,
  id,
  complexId,
  price,
  sport,
  cover,
  weekdays,
  weekend,
  tribune,
  type,
  lighting,
  workingHours,
  workingHoursTypes,
  workingHoursSports,
  sports, // Если передан sports напрямую (уже с числовыми ключами), используем его
}) => {
  const model = {
    id,
    name,
    complexId,
    price,
    sport,
    cover,
    weekdays,
    weekend,
    tribune,
    lighting,
    type,
    workingHours,
    workingHoursTypes,
    // Приоритет: если передан sports (уже с числовыми ключами), используем его
    // Иначе используем workingHoursSports (который нужно преобразовать)
    sports: sports || workingHoursSports,
  };

  const response = await api.updatePlayground(model);
  
  console.log('📥 Ответ от api.updatePlayground:', response);
  console.log('📥 response.sports:', response?.sports);

  // Если API возвращает sports, используем их, иначе используем переданные данные
  const { sports: responseSports, ...playground } = response || {};
  
  console.log('📥 responseSports после деструктуризации:', responseSports);
  console.log('📥 playground после деструктуризации:', playground);
  
  // Преобразуем sports из формата { 0: [32, 128], 1: [32] } в формат { "full": [32, 128], "half": [32] }
  // для правильного хранения в Redux и использования в Playground.js (ключи должны быть строковыми: 'full', 'half', 'third')
  let workingHoursSportsForRedux = {};
  // ВАЖНО: преобразуем только если responseSports не пустой и содержит данные
  if (responseSports && typeof responseSports === 'object' && Object.keys(responseSports).length > 0) {
    Object.keys(responseSports).forEach(key => {
      // Преобразуем числовые ключи (0, 1, 2) или строковые числовые ("0", "1", "2") в строковые ключи ('full', 'half', 'third')
      let typeKey = key;
      const keyStr = String(key);
      if (key === 0 || keyStr === '0') typeKey = 'full';
      else if (key === 1 || keyStr === '1') typeKey = 'half';
      else if (key === 2 || keyStr === '2') typeKey = 'third';
      
      const sportArray = responseSports[key];
      // Проверяем, что массив не пустой
      if (Array.isArray(sportArray) && sportArray.length > 0) {
        // КРИТИЧНО: Преобразуем числовые флаги в строковые ключи для хранения в Redux
        // Это нужно, чтобы Playground.js мог правильно работать с данными
        const sportKeys = sportFlagsToKeysArray(sportArray);
        workingHoursSportsForRedux[typeKey] = sportKeys;
        console.log(`📥 Преобразовали ${typeKey}: числовые флаги ${JSON.stringify(sportArray)} -> строковые ключи ${JSON.stringify(sportKeys)}`);
      }
    });
  }
  
  console.log('📥 workingHoursSportsForRedux:', workingHoursSportsForRedux);
  console.log('📥 responseSports:', responseSports);
  console.log('📥 workingHoursSportsForRedux keys:', Object.keys(workingHoursSportsForRedux));

  return {
    type: UPDATE_PLAYGROUND,
    payload: {
      ...playground,
      // ВАЖНО: передаем workingHoursSportsForRedux только если он не пустой
      // Если пустой, не передаем вообще, чтобы Playground.js мог сохранить текущие данные
      ...(Object.keys(workingHoursSportsForRedux).length > 0 ? { workingHoursSports: workingHoursSportsForRedux } : {}),
      sports: responseSports, // Также сохраняем sports для использования в Playground.js
    },
  };
};

export const uploadPhoto = async (file, id) => {
  const image = await api.uploadPhoto(file, id);

  return {
    type: UPLOAD_PHOTO,
    payload: {
      playground: id,
      image,
    },
  };
};

export const deletePhoto = async (playground, id) => {
  await api.deletePhoto(id);
  return {
    type: DELETE_PHOTO,
    payload: {
      playground,
      id,
    },
  };
};

export const setCover = async (playground, images, id) => {
  for (const i of images) {
    if (i.isMain) {
      await api.updatePhoto(i.id, { isMain: false });
    }
  }

  await api.updatePhoto(id, { isMain: true });

  return {
    type: SET_COVER_PHOTO,
    payload: {
      playground,
      id,
    },
  };

  // const result = await api.update
};

export const deletePlayground = async (id) => {
  const responseData = await api.deletePlayground(id);
  return {
    type: DELETE_PLAYGROUND,
    payload: responseData,
  };
};

export const getTimetable = async (division, playgroundId) => {
  const responseData = await api.getTimetable(playgroundId, division);
  return {
    type: SET_TIMETABLE,
    payload: {
      playgroundId,
      timetable: responseData,
    },
  };
};

export const addTimetable = async (playgroundId, type) => {
  return {
    type: ADD_TIMETABLE,
    payload: {
      playgroundId,
      type,
    },
  };
};

export const fetchPlaygrounds = async () => {
  const playgrounds = await api.getPlaygrounds();
  return {
    type: FETCH_PLAYGROUNDS,
    payload: playgrounds,
  };
};

export default reducer;
